import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges, signal } from "@angular/core";
import { NgFor } from "@angular/common";

import { Profile } from "../../models/profile";
import { SwipeCardComponent, SwipeDecision } from "../swipe-card/swipe-card.component";

@Component({
  selector: "app-swipe-deck",
  standalone: true,
  imports: [NgFor, SwipeCardComponent],
  templateUrl: "./swipe-deck.component.html",
  styleUrl: "./swipe-deck.component.scss"
})
export class SwipeDeckComponent implements OnChanges {
  @Input({ required: true }) profiles: readonly Profile[] = [];

  @Output() swipeRight = new EventEmitter<Profile>();
  @Output() swipeLeft = new EventEmitter<Profile>();
  @Output() superLike = new EventEmitter<Profile>();

  readonly maxVisible = 3;

  /** Drag offset for the top card only (background cards stay stacked in place). */
  readonly deckDx = signal(0);
  readonly deckDy = signal(0);
  /** True while the top card is tracking a pointer drag (disables CSS transition on visible cards). */
  readonly deckDragging = signal(false);

  private previousTopId: string | null = null;

  ngOnChanges(changes: SimpleChanges): void {
    if (!changes["profiles"]) return;
    const topId = this.profiles[0]?.id ?? null;
    if (topId !== this.previousTopId) {
      this.previousTopId = topId;
      this.deckDx.set(0);
      this.deckDy.set(0);
      this.deckDragging.set(false);
    }
  }

  trackById(_: number, p: Profile): string {
    return p.id;
  }

  onDeckOffsetChange(ev: { dx: number; dy: number }, index: number): void {
    if (index !== 0) return;
    this.deckDx.set(ev.dx);
    this.deckDy.set(ev.dy);
  }

  onDeckDragActiveChange(active: boolean, index: number): void {
    if (index !== 0) return;
    this.deckDragging.set(active);
  }

  onDecision(ev: { profile: Profile; decision: SwipeDecision }): void {
    if (ev.decision === "right") this.swipeRight.emit(ev.profile);
    if (ev.decision === "left") this.swipeLeft.emit(ev.profile);
  }
}

